import React from 'react'

const imageError = () => (
  
  <section className="hero is-fullheight-with-navbar is-info">
    <div className="hero-body">
      <div className="container">
        <p className="title is-1 has-text-centered has-text-white">Oops our database does not recognise that. Please try again</p>
      </div>
    </div>
  </section>
)
export default imageError